import React from 'react';
import { useSelector } from 'react-redux';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import type { HGPokerGameTile } from '@swf/core/types/Poker';

interface Props {
  className?: string;
  supported?: boolean;
  encodedEndpoint?: string;
  url?: string;
  link: HGPokerGameTile['link'];
  id: HGPokerGameTile['id'];
  clubId: HGPokerGameTile['clubId'];
}

interface StarsWeb {
  homegames: {
    openTable: (obj: object | undefined) => void;
    openTourn: (obj: object | undefined) => void;
  };
}

const Wrapper: React.FC<Props> = ({ children, className, supported, clubId, id, link, url }) => {
  const isEmbedded = useSelector(select.site.isEmbedded);
  const newTab = useFeature(FeatureFlag.HomeGamesNewTab);

  const handleGameClick = () => {
    if (!supported) return;

    if (isEmbedded) {
      const starsWeb = window.starsweb as StarsWeb;

      if (link === 'joinTable') {
        starsWeb?.homegames?.openTable({ tableId: id, clubId });
      } else if (link === 'joinTourn') {
        starsWeb?.homegames?.openTourn({ tournId: id, clubId });
      }
    }
  };

  return newTab && !isEmbedded ? (
    <a
      href={newTab && supported && url ? url : undefined}
      target="_blank"
      className={className}
      onClick={handleGameClick}
      rel="noreferrer"
    >
      {children}
    </a>
  ) : (
    <div className={className} onClick={handleGameClick}>
      {children}
    </div>
  );
};

export default Wrapper;
